import clsx from 'clsx'
import type { ReactNode } from 'react'

type InfoBannerTone = 'sand' | 'peach' | 'sky'

interface InfoBannerProps {
  icon?: ReactNode
  title?: ReactNode
  description: ReactNode
  tone?: InfoBannerTone
  className?: string
}

const TONE_CLASSES: Record<InfoBannerTone, string> = {
  sand: 'bg-sand-25 text-charcoal',
  peach: 'bg-peach-25 text-charcoal',
  sky: 'bg-sky-25 text-charcoal',
}

export function InfoBanner({
  icon,
  title,
  description,
  tone = 'sand',
  className,
}: InfoBannerProps) {
  return (
    <div
      className={clsx(
        'flex items-start gap-3 rounded-lg border border-sand-dark p-4',
        TONE_CLASSES[tone],
        className
      )}
    >
      {icon && (
        <span className="flex-shrink-0 text-base text-charcoal-75" aria-hidden="true">
          {icon}
        </span>
      )}
      <div className="flex flex-col gap-1 text-sm leading-snug">
        {title && <p className="font-semibold text-charcoal">{title}</p>}
        <div className="text-charcoal-75">{description}</div>
      </div>
    </div>
  )
}
